import { Construction } from 'lucide-react'
import { Button } from './button'

export default function EmptyList({
  pathname,
}: {
  pathname: string
}) {
  return (
    <div className="w-full flex flex-col border rounded-lg space-y-3 mt-10 text-center items-center px-6 py-12">
      <Construction className="h-16 w-16 text-amber-400" />
      <p className="text-xl font-semibold w-full">
        Nenhum resultado encontrado
      </p>
      <p className="text-md">
        Talvez você possa tentar inserir um termo diferente ou remover o filtro
        da sua pesquisa.
      </p>
      <Button
        variant="link"
        asChild
        className="text-primary border border-orange-500 hover:bg-orange-500 hover:text-white"
      >
        <a href={pathname}>Remover filtro</a>
      </Button>
    </div>
  )
}
